module.exports = __webpack_public_path__ + "static/media/ETH-AVAX.ba6a7fd9.svg";